import {Component, Inject, OnInit} from '@angular/core';
import {ComponentCleaner} from '../../../../component-cleaner';
import {PermissionWrapper} from '../../../../directives/if-permission.directive';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {CustomerGroupService} from '../../../customer-group/customer-group.service';
import {ManagerUserDaoService} from '../../../manager-user/manager-user-dao.service';
import {FormBuilder, FormControl, FormGroup, ValidationErrors} from '@angular/forms';
import {EntityHistoryComponent} from '../../../javers/entity-history/entity-history.component';
import {GuacServerDaoService} from '../guac-server-dao.service';
import {convertToFormGroup, CrudOperationWrapper, markAsTouched} from '../../../../helpers/kluh';
import {CustomerGroup, GatewayServerWithPassword, GuacServer} from 'app/kluh-manager/models';
import {Observable} from 'rxjs/internal/Observable';
import {ConfirmDialogComponent} from '../../../../helpers/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-guac-server-edit',
    templateUrl: './guac-server-edit.component.html',
    styleUrls: ['./guac-server-edit.component.scss']
})
export class GuacServerEditComponent extends ComponentCleaner implements OnInit {
    canEditList: PermissionWrapper[];
    customerGroup: CustomerGroup;
    myForm: FormGroup;
    guacServer: GuacServer;
    changePassword = false;
    passwordError = false;
    guacServerPasswordForm: FormControl = new FormControl();
    guacServerPasswordRepeatForm: FormControl = new FormControl();

    constructor(
        public dialogRef: MatDialogRef<GuacServerEditComponent>,
        private customerGroupService: CustomerGroupService,
        private fb: FormBuilder,
        private guacServerDaoService: GuacServerDaoService,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super();
        this.guacServer = data.guacServer ?? this.guacServerDaoService.initGuacServer();
        this.guacServer.customerGroupId = data.guacServer?.customerGroupId ?? data.customerGroupId;
        this.myForm = this.fb.group(
            convertToFormGroup(this.guacServer), {asyncValidator: this.guacServerDaoService.validator}
        );

    }


    ngOnInit(): void {
        this.addSubscription(this.guacServerPasswordForm.valueChanges.subscribe(() => {
            markAsTouched(this.myForm);
            this.checkPassword();
        }));
        this.addSubscription(this.guacServerPasswordRepeatForm.valueChanges.subscribe(() => {
            markAsTouched(this.myForm);
            this.checkPassword();
        }));
        this.customerGroupService.get().subscribe(customerGroup => {
            if (customerGroup) {
                this.customerGroup = customerGroup;
            }
        });
    }

    private checkPassword(): void {
        const password = this.guacServerPasswordForm.value;
        const passwordRepeat = this.guacServerPasswordRepeatForm.value;
        if (password !== passwordRepeat) {
            const errors: ValidationErrors = {};
            this.guacServerPasswordRepeatForm.setErrors(errors);
            this.passwordError = true;
        } else {
            this.guacServerPasswordRepeatForm.setErrors(null);
            this.passwordError = false;
        }
    }


    onSubmit(): void {
        const guacServer: GuacServer = this.myForm.value;
        guacServer.secretKey = this.guacServerPasswordForm.value;
        this.save(guacServer);
    }

    private save(guacServer: GuacServer): void {
        this.guacServerDaoService.checkIfCanCreate(guacServer).subscribe((canCreate) => {
            if (!canCreate) {
                const fqdn = guacServer.fqdn;
                const port = guacServer.port || 8080;
                this.alertMessage('Esse FQDN e Porta já está em uso<br><br><b>' + fqdn + ' : ' + port + '</b>');
            } else {
                let saveOrCrete$: Observable<GuacServer>;
                if (guacServer.id) {
                    saveOrCrete$ = this.guacServerDaoService.save(guacServer);
                } else {
                    saveOrCrete$ = this.guacServerDaoService.create(guacServer);
                }
                saveOrCrete$.subscribe(result => {
                    const crudOperation: CrudOperationWrapper = {
                        data: result,
                        operation: 'SAVE'
                    };
                    this.dialogRef.close(crudOperation);
                });
            }
        });
    }

    private alertMessage(message: string): void {
        this.addSubscription(
            this.dialog.open(ConfirmDialogComponent, {
                disableClose: true,
                data: {
                    message: message,
                    disableCancel: true,
                    confirmButtonValue: 'OK',
                    icon: 'error_outline'
                }
            }).afterClosed().subscribe(() => {
            })
        );
    }

    setChangePassword(): void {
        this.changePassword = true;
    }

    isValidPassword(): boolean {
        return !(
            this.passwordError
            || this.guacServerPasswordForm.value?.length < 1
            || this.guacServerPasswordRepeatForm.value?.length < 1
            || this.guacServerPasswordForm.value?.length > 32
            || this.guacServerPasswordRepeatForm.value?.length > 32);
    }


    onRemove(): void {
        const subscription = this.dialog.open(ConfirmDialogComponent, {
            disableClose: true,
            data: {
                message: '<div>Tem certeza que deseja deletar esse Guac Server? ' +
                    '<br><br> Para remover digite <u>DELETE</u> no campo abaixo</div>',
                disableCancel: false,
                cancelButtonValue: 'Cancelar',
                confirmButtonValue: 'Deletar',
                icon: 'error_outline',
                confirmFieldValue: 'DELETE'
            }
        }).afterClosed().subscribe((result) => {
            if (result) {
               this.guacServerDaoService.canDelete(this.guacServer.id).subscribe((canDelete) => {
                    if (canDelete) {
                        this.guacServerDaoService.remove(this.guacServer.id).subscribe(() => {
                            const crudOperation: CrudOperationWrapper = {
                                data: this.guacServer,
                                operation: 'DELETE'
                            };
                            this.dialogRef.close(crudOperation);
                        });
                    } else {
                        this.alertMessage('<h1>Guac Server não pode ser deletado</h1><div class="mb-60"><b>Não pode ser deletado</b>' +
                            ' esse Guaca Server está sendo usado.</div>');
                    }
                });

            }
        });
        this.addSubscription(subscription);
    }

    onCancel(): void {
        this.dialogRef.close({
            operation: 'CANCEL'
        } as CrudOperationWrapper);
    }

    onJaversHistory(): void {
        EntityHistoryComponent.openHistory(this.guacServer.id, this.guacServerDaoService, this.dialog);
    }

    onJaversAllHistory(): void {
        EntityHistoryComponent.openAllHistory(this.guacServer.id, this.guacServerDaoService, this.dialog);
    }
}
